module.exports = __webpack_public_path__ + "img/sm.e050aeb4.jpg";